import { ArrowRightFromBracketRegularIcon } from "@elixir/icons";
import { Modal } from "antd";
import { PrimaryButton, SecondaryButton } from "ui";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";

const ExitFlowPopup = ({
  show,
  closePopup,
}: {
  show: boolean;
  closePopup: () => void;
}) => {
  const clearHprHfrStore = useHprHfrOnboardingStore(
    (state) => state.clearHprHfrStore
  );
  const handleExit = () => {
    clearHprHfrStore();
  };
  return (
    <Modal
      // title="Are you sure you want to exit?"
      open={show}
      bodyStyle={{ padding: 0 }}
      onCancel={closePopup}
      footer={null}
      destroyOnClose={true}
      style={{
        padding: 0,
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <div className="dr-rounded-8">
        <div className="dr-p-16 dr-text-darwin-touch-neutral-1000 Title3Regular dr-border-b-1 dr-border-darwin-touch-neutral-200 dr-rounded-t-8">
          Are you sure you want to exit?
        </div>
        <div className="dr-px-16 dr-py-24 dr-text-darwin-touch-neutral-1000 SubheadlineRegular dr-border-b-1 dr-border-darwin-touch-neutral-200">
          All the changes you have made will be lost
        </div>
        <div className="dr-flex dr-justify-end dr-items-center dr-space-x-16 dr-px-16 dr-py-12">
          <SecondaryButton title="Cancel" onClick={closePopup} />
          <PrimaryButton
            title="Yes, Exit"
            onClick={handleExit}
            IconComponent={() => (
              <ArrowRightFromBracketRegularIcon className="dr-w-14 dr-h-14" />
            )}
          />
        </div>
      </div>

      {/* <div>All the changes you have made will be lost.</div> */}
    </Modal>
  );
};

export default ExitFlowPopup;
